
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class PaymentSchedulePlanReaderService {

   public static getAccountBalanceList(
           axiosInstance: AxiosInstance, input: ServerData.PaymentSchedulePlanWebReader.GetAccountBalanceList$Input,
           f: (output: ServerData.PaymentSchedulePlanWebReader.GetAccountBalanceList$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'spineapi/paymentscheduleplan/get-account-balance-list',
            {params : input.toJson()}
        ).then((response) => ServerData.PaymentSchedulePlanWebReader.GetAccountBalanceList$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

